import React from 'react';
import cn from 'classnames';
import Markup from 'components/Markup';

import * as styles from './list.module.scss';

export function Component({ content: { description, list }, className, theme }) {
  return (
    <div className={cn(styles.wrapper, className)}>
      {description && <p className={styles.listTitle}>{description}</p>}
      <ul className={styles.list}>
        {list.map(item => {
          return (
            <Markup key={item} tag="li" className={cn(styles.listItem, styles[theme])}>
              {item}
            </Markup>
          );
        })}
      </ul>
    </div>
  );
}
